import i18n from 'i18next';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getAccessToken } from '../../services/AccessToken';
import { STUDY_SONG_API_URL } from '../../services/Constants';
import { studySongActionTypes } from './Constants';
import { processRequest } from '../../services/Api';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as notificationActions from '../../components/notification/Actions';
import * as studySongActions from './Actions';

export default function* () {
	yield all([
		yield takeLatest(studySongActionTypes.GENERATE_SONG_REQUEST, handleGenerateSongRequest),
		yield takeLatest(
			studySongActionTypes.GET_SONG_DETAILS_REQUEST,
			handleGetSongDetailsRequest,
		),
		yield takeLatest(
			studySongActionTypes.FAVORITE_UNFAVORITE_SONG_REQUEST,
			handleFavoriteUnfavoriteSongRequest,
		),
	]);
}

export function* handleGenerateSongRequest({ payload }) {
	try {
		const { data: reqPayload } = payload;

		const { data } = yield call(
			processRequest,
			STUDY_SONG_API_URL,
			'POST',
			reqPayload,
			false,
			false,
			{ 'X-Auth-Token': getAccessToken() },
			true,
		);

		yield put(
			studySongActions.generateSongSuccess({
				...data,
				words: Object.keys(data.word_images),
			}),
		);
	} catch (e) {
		yield put(studySongActions.generateSongError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}

export function* handleGetSongDetailsRequest({ payload }) {
	try {
		const { songId } = payload;

		const { data } = yield call(processRequest, `public/donk_ai/${songId}`);
		const { donk_ai_song, no_index } = data || {};

		yield put(
			studySongActions.getSongDetailsSuccess({
				...donk_ai_song,
				words: Object.keys(donk_ai_song.word_images),
				no_index,
			}),
		);
	} catch (e) {
		yield put(studySongActions.getSongDetailsError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}

export function* handleFavoriteUnfavoriteSongRequest({ payload }) {
	try {
		const { songId, isFavorite } = payload;
		yield call(
			processRequest,
			`donk_ai/${songId}/${isFavorite ? 'favorite_song' : 'unfavorite_song'}`,
			isFavorite ? 'POST' : 'DELETE',
		);
		yield put(studySongActions.favoriteUnfavoriteSongSuccess(isFavorite));
		if (isFavorite)
			yield put(
				notificationActions.createNotification(
					i18n.t('study_song.favorite_song_notification'),
				),
			);
	} catch (e) {
		yield put(studySongActions.favoriteUnfavoriteSongError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}
